import axios from "axios";

// export const BaseURL = "http://192.168.1.81:8000/"
// export const BaseURL = process.env.REACT_APP_BASE_URL
export const BaseURL = "https://ppsk.api.adharbranch.mitlive.cloud/"
export const BucketURL = "https://webitodevelopment.s3.ap-south-1.amazonaws.com/"


export const ApiGetNoAuth = (type) => {
    return new Promise((resolve, reject) => {
        axios
            .get(BaseURL + type)
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    reject(error?.response?.data);
                } else {
                    reject(error?.response);
                }
            });
    });
};

export const ApiPostNoAuth = (type, userData) => {
    return new Promise((resolve, reject) => {
        axios
            .post(BaseURL + type, userData)
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    reject(error?.response?.data);
                } else {
                    reject(error?.response);
                }
            });
    });
};

export const ApiPutNoAuth = (type, userData) => {
    return new Promise((resolve, reject) => {
        axios
            .put(BaseURL + type, userData)
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    reject(error?.response?.data);
                } else {
                    reject(error?.response);
                }
            });
    });
};

export const ApiDeleteNoAuth = (type) => {
    return new Promise((resolve, reject) => {
        axios
            .put(BaseURL + type)
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    reject(error?.response?.data);
                } else {
                    reject(error?.response);
                }
            });
    });
};

export const ApiGet = (type) => {
    return new Promise((resolve, reject) => {
        axios
            .get(BaseURL + type, {
                headers: {
                    Authorization: localStorage.getItem("auth_token"),
                },
            })
            .then((responseJson) => {
                return (console.log(responseJson, 'resjson'),
                    resolve(responseJson))
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    if (error?.response?.status === 403) {
                        //   signout();
                    } else {
                        reject(error?.response?.data);
                    }
                } else {
                    reject(error);
                    if (error?.response?.data?.message === "Token has expired") {
                        localStorage.clear();

                    }
                }
            });
    });
};

export const ApiPost = (type, userData) => {
    return new Promise((resolve, reject) => {
        axios
            .post(BaseURL + type, userData, {
                headers: {
                    Authorization: localStorage.getItem("auth_token"),
                },
            })
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    if (error?.response?.status === 403) {
                    } else {
                        reject(error?.response?.data);
                    }
                } else {
                    reject(error);
                    if (error?.response?.data?.message === "Token has expired") {
                        localStorage.clear();
                    } else if (error?.response?.data?.message === "Too Many Attempts.") {
                        alert("Please wait 2 minute, after 2 minute reload website.");
                    }
                }
            });
    });
};

export const ApiDelete = (type, userData) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(BaseURL + type, {
                data: userData,
                headers: {
                    Authorization: localStorage.getItem("auth_token"),
                },
            })
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    if (error?.response?.status === 403) {
                        //   signout();
                    } else {
                        reject(error?.response?.data);
                    }
                } else {
                    reject(error);
                }
            });
    });
};

export const ApiPut = (type, userData) => {
    return new Promise((resolve, reject) => {
        axios
            .put(BaseURL + type, userData, {
                headers: {
                    Authorization: localStorage.getItem("auth_token"),
                },
            })
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch((error) => {
                if (
                    error?.hasOwnProperty("response") &&
                    error?.response?.hasOwnProperty("data") &&
                    error?.response?.data?.hasOwnProperty("error") &&
                    error?.response?.data?.error
                ) {
                    if (error?.response?.status === 403) {
                        // Handle 403 (forbidden) status here if needed
                    } else {
                        reject(error?.response?.data);
                    }
                } else {
                    reject(error);
                    if (error?.response?.data?.message === "Token has expired") {
                        localStorage.clear();
                    } else if (error?.response?.data?.message === "Too Many Attempts.") {
                        alert("Please wait 2 minutes, then reload the website.");
                    }
                }
            });
    });
};
